import React from 'react';
import { PLANNER_COLORS } from '../../shared_components';
import { TEXT } from '../../shared_components';

const InactivityCell = ({ inactivity }) => {
  if (!inactivity || inactivity?.suppressed) return <span style={{ color: TEXT.tertiary, fontStyle: 'italic', fontSize: 13 }}>Suppressed</span>;
  if (inactivity?.hours == null) return <span style={{ color: TEXT.tertiary }}>--</span>;
  if (inactivity?.is_escalated) return <span style={{ color: PLANNER_COLORS.red, fontWeight: 700, fontSize: 13 }}>🔴 {inactivity.hours}h</span>;
  return <span style={{ color: PLANNER_COLORS.orange, fontWeight: 700, fontSize: 13 }}>⏳ {inactivity?.hours}h</span>;
};

export default InactivityCell;
